import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17579a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero" }
const _hoisted_2 = {
  key: 0,
  class: "container mt-5"
}
const _hoisted_3 = { class: "container mt-5" }
const _hoisted_4 = { class: "row col-12 my-3 justify-content-center" }
const _hoisted_5 = { class: "col-sm-12 col-md-8 offset-md-1 col-sm-12 offset-sm-0 col-lg-6 offset-lg-1 card" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Account application type", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Individual Application", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-8 offset-md-1 col-lg-6 offset-lg-1 col-sm-12 offset-sm-0 card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-end mx-md-0 mx-1 mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-lg-4 col-md-4 px-1" }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "submit",
        class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
      }, " Proceed ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      (_ctx.in_verification==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(_ctx.main_msg), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.in_verification==0)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              method: "POST",
              action: "/",
              class: "my-1 p-2",
              onSubmit: _ctx.app_proceed
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_Field, {
                        style: {"font-size":"18px!important"},
                        modelValue: _ctx.applicant_type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.applicant_type) = $event)),
                        class: "form-control",
                        name: "applicant_type",
                        as: "select",
                        rules: _ctx.selectField
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: ""
                          }, "Please select", 8, _hoisted_8),
                          _hoisted_9,
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "2"
                          }, "Corporate Application", 8, _hoisted_10),
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "3"
                          }, "Trust Application", 8, _hoisted_11),
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "4"
                          }, "Agents Application", 8, _hoisted_12),
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "5"
                          }, "Association Application", 8, _hoisted_13),
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "6"
                          }, "Government Bodies Application", 8, _hoisted_14),
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "7"
                          }, "Partnership Application", 8, _hoisted_15),
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "8"
                          }, "Registered Co-Operative Application", 8, _hoisted_16),
                          _createElementVNode("option", {
                            disabled: 'disabled'?_ctx.is_director==1:'',
                            value: "9"
                          }, "Politically Exposed Persons Application", 8, _hoisted_17)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "rules"]),
                      _createVNode(_component_ErrorMessage, {
                        style: {"color":"#d00000"},
                        name: "applicant_type"
                      })
                    ])
                  ]),
                  _hoisted_18
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}